import styled from 'styled-components';

export const TitleWrapper = styled.div`
  text-align: ${({ align }) => align || 'center'};
  font-size: ${({ fontSize }) => fontSize || '2rem'};
  margin: ${({ margin }) => margin || '0.75rem 1rem'};
  background-color: ${({ background }) => background || 'transparent'};
  color: ${({ color }) => color || '#000'};
  padding: ${({ padding }) => padding || '1rem 0'};

  @media (max-width: 768px) {
    font-size: ${({ fontSizeMobile }) => fontSizeMobile || '1.5rem'};
    margin: ${({ marginMobile }) => marginMobile || '0.5rem 1rem'};
    padding: ${({ paddingMobile }) => paddingMobile || '0.75rem 0'};
  }
`;